import { ENVIRONMENT_COMMON } from './environment.common';

export const ENVIRONMENT = {
  ...ENVIRONMENT_COMMON,
  onProd: false,
  apiBaseUrl: 'https://crh.test.sellions.com/',
  engineUrl: 'https://crh-engine.test.sellions.com/',
  authSecret: 'f1344d75-8a2c-4130-94c5-7c4906381363',
  authServerBaseUrl: 'https://kc.test.sellions.com/',
  authRealm: 'crh',
  userCredsAuthEnabled: false,
  authLoginRedirect: 'https://crh-web.test.sellions.com/',
  versionUrl: 'dummy',
  codePushDeploymentKeyAndroid: 'i_t_jJHJjHuVvDD9b1PePL5jiPdyylyQDPg65',
  codePushDeploymentKeyIOS: 'JPncwKUOYc387en5JLrvaEGzgNezYwaZy7ndc',
};



// WEBPACK FOOTER //
// ./environments/environment.ts